import { connect } from 'react-redux';
import { withApollo, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import UsersSearch from '../../components/SearchUsers';
import { setWarningMessage, setErrorMessage } from '../../actions/messages';

export default compose(
  withApollo,
)(withRouter(connect(null, { setWarningMessage, setErrorMessage })(UsersSearch)));



// WEBPACK FOOTER //
// ./src/app/containers/SearchUsers/index.js